let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '服务记录',
        props: 'serviceRecord',
        minWidth: 200,
    },
    {
        label: '编号',
        props: 'feedbackNo',
        minWidth: 300,
        tooltip:true,
    },
    {
        label: '运营商名称',
        props: 'serviceToName',
        minWidth: 200,
    },
    {
        label: '提交人',
        props: 'createdByName',
        minWidth: 200,
    },
    {
        label: '最后提交时间',
        props: 'lastModifiedWhen',
        minWidth: 200,
    },
];

// // 面包屑
pageConfig.listBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '服务记录'
}];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'feedbackId',
    editRouter: 'serviceRecordDetail',
};

// 路由
pageConfig.listRouter = 'serviceRecordList';

// 详情的面包屑
pageConfig.detailBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'router',
    name: '服务记录',
    router: 'serviceRecordList'
},
{
    type: 'title',
    name: '服务记录详情',
}
];

pageConfig.formRules = {
    serviceToName: [{
        required: true,
        message: '请填写运营商名称',
        trigger: 'blur'
    }],
    serviceToTypeName: [{
        required: true,
        message: '请选择服务对象',
        trigger: 'change'
    }],
    backInfo: [{
        required: true,
        message: '请填写背景信息',
        trigger: 'blur'
    }],
    serviceRecord: [{
        required: true,
        message: '请填写服务记录',
        trigger: 'blur'
    }],
};



export default pageConfig;